import React, { useEffect, useState } from "react";
import { Link } from 'react-router-dom';
import { useTranslation } from "react-i18next";
import configVars from "../../config";
import { getWithExpiry, setWithExpiry } from "../../common";

const RecentArticles = () => {

	const [recentPosts, setRecentPosts] = useState([]);
	const [loading, setLoading] = useState(false);
	const [translation] = useTranslation("translations");

	useEffect(() => {

		const recentNews = getWithExpiry( 'recent_news_posts' );

		if ( recentNews ) {
			setRecentPosts( recentNews );
		} else {

			(async () => {

				setLoading(true);
		
				const response = await fetch(
				  `${configVars.apiUrl}sustainchange/v1/getrecentnews`,
				  {
					method: "GET",
					headers: {
					  Authorization: `Basic ${configVars.auth}`,
					},
				  }
				);
		
				const newsResponse = await response.json();
		
				if (newsResponse && newsResponse.data) {

					setRecentPosts( newsResponse.data );
					setWithExpiry( 'recent_news_posts', newsResponse.data );

					setLoading(false);
				  
				}
		
				setLoading(false);
			})();

		}

	}, []);

    return(
        <div className="recent-articles-wrap">

			{ loading &&
				<div className="mb-3">
					<h5>{translation('latest_articles')}</h5>
					<div className="d-flex justify-content-center mt-5">
						<div className="spinner-border text-primary" role="status" >
						<span className="visually-hidden">Loading...</span>
						</div>
					</div>
				</div>
			}

			{recentPosts && recentPosts.length > 0 &&
				<>
					<div className="mb-2 d-flex align-items-center">
						<h5 className="flex-grow-1">{translation('latest_articles')}</h5>
						<Link to="/kunskap-inspiration/forandra-ditt-liv/" className="text-secondary d-inline-block text-decoration-none">
							<span className="pe-2">{translation('view_all')}</span>
							<i className="fa fa-angle-double-right" aria-hidden="true"></i>
						</Link>
					</div>
				
					{ recentPosts.map( (recentPost, index) => {
							return(
								<div className="py-2 border-bottom" key={index}>
									<div className="row align-items-center">
										<div className="col-2">
											<img className="d-block w-100" src={recentPost.post_thumbnail} alt={recentPost.post_title} />
										</div>
										<div className="col-9 col-lg-8">
											<p className="mb-1 font-size-medium" dangerouslySetInnerHTML={{__html: recentPost.post_title}}></p>
											<p className="opacity-half font-size-medium mb-0" dangerouslySetInnerHTML={{__html: recentPost.post_excerpt}}></p>
										</div>
										<div className="col-12 col-lg-2 px-lg-0 text-end">
											<Link to={`/kunskap-inspiration/forandra-ditt-liv/p/${recentPost.post_id}`} className="btn p-0 btn-link font-size-medium btn-sm mb-3 text-decoration-none text-secondary">
												<span className="pe-1">{translation('read_more')}</span>
												<i className="fa fa-angle-double-right" aria-hidden="true"></i>
											</Link>
										</div>
									</div>
								</div>
							)
						})}

				</>
			}

        </div>
    )
}

export default RecentArticles;